import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { usePathname } from 'shared/hooks/useRouterPath';
import { APP_ROUTES } from 'shared/routes';
import { useTranslation } from 'shared/translations';
type CurrentPageTranslationKey = 'home' | 'recommendations' | 'reportingSolutions' | 'connectors' | 'attributionModels' | 'dataSources' | 'budgetOptimiser' | 'mimir' | 'workspace' | 'enhancedSignals' | 'customGroupings' | 'creativeReporting' | 'creativeAssets' | 'account' | 'copilot' | 'fallback';

/**
 * Human-readable label for the page the user is on, for Copilot context UI.
 * Refine route → label mapping as product needs evolve.
 */
export const useCopilotCurrentPageLabel = () => {
  const $ = _c(6);
  const {
    pathname
  } = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot.currentPage"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== pathname || $[2] !== t) {
    const key = getCurrentPageTranslationKey(pathname);
    t1 = t(key);
    $[1] = pathname;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const label = t1;
  let t2;
  if ($[4] !== label) {
    t2 = {
      label
    };
    $[4] = label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const getCurrentPageTranslationKey = (pathname: string): CurrentPageTranslationKey => {
  if (pathname.startsWith(APP_ROUTES.budgetOptimiser.basePage)) return 'budgetOptimiser';
  if (pathname.startsWith(APP_ROUTES.attributionModels.basePage)) return 'attributionModels';
  if (pathname.startsWith(APP_ROUTES.enhancedSignals.basePage)) return 'enhancedSignals';
  if (pathname.startsWith(APP_ROUTES.customGroupings.basePage)) return 'customGroupings';
  if (pathname.startsWith(APP_ROUTES.dataSources.basePage)) return 'dataSources';
  if (pathname.startsWith(APP_ROUTES.connectors.basePage)) return 'connectors';
  if (pathname.startsWith(APP_ROUTES.reportingSolutions.basePage)) return 'reportingSolutions';
  if (pathname.startsWith(APP_ROUTES.creativeReporting.basePage)) return 'creativeReporting';
  if (pathname.startsWith(APP_ROUTES.creativeAssets.basePage)) return 'creativeAssets';
  if (pathname.startsWith(APP_ROUTES.recommendations.basePage)) return 'recommendations';
  if (pathname.startsWith(APP_ROUTES.mimir.basePage)) return 'mimir';
  if (pathname.startsWith(APP_ROUTES.workspace.basePage)) return 'workspace';
  if (pathname.startsWith(APP_ROUTES.account.basePage)) return 'account';
  if (pathname.startsWith(APP_ROUTES.copilot.basePage)) return 'copilot';
  if (pathname === '/' || pathname === '') return 'home';
  return 'fallback';
};